import { ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { UploadFileComponent, UploadFileConfig } from 'src/app/components/main/shared/upload-file-dialog/upload-file-dialog.component';
import { UploadFileDialogResult } from 'src/app/components/main/shared/upload-file-dialog/interfaces/UploadFileDialogResult';

@Component({
  selector: 'app-absence-request-dialog',
  imports: [MatDialogModule, MatButtonModule, UploadFileComponent],
  templateUrl: './absence-request-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AbsenceRequestDialogComponent {
  readonly dialogRef = inject(MatDialogRef<AbsenceRequestDialogComponent>);
  readonly data = inject<UploadFileConfig>(MAT_DIALOG_DATA);

  @ViewChild('uploadComponent') uploadComponent!: UploadFileComponent;

  uploadConfig: UploadFileConfig = {
    ...this.data,
    title: '', // El título lo maneja el mat-dialog-title
  };

  onSave(): void {
    const result: UploadFileDialogResult = {
      files: this.uploadComponent.getFiles(),
      comment: this.uploadComponent.getComment(),
    };
    this.dialogRef.close(result);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  isValid(): boolean {
    return this.uploadComponent?.isValid() ?? false;
  }
}
